module.exports = __webpack_public_path__ + "images/ynpk10ff.e019.png";